import { API } from '@/config/api';
import React, { useState, useEffect } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Scale } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { toast } from 'sonner';


export default function WeightTracker() {
  const [weight, setWeight] = useState('');
  const [history, setHistory] = useState([]);

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      const response = await fetch(`${API}/tracking/weight/history`, {
        credentials: 'include'
      });
      if (response.ok) {
        const data = await response.json();
        setHistory(data.reverse());
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
    }
  };

  const handleLog = async () => {
    if (!weight) return;

    try {
      const response = await fetch(`${API}/tracking/weight?weight_kg=${parseFloat(weight)}`, {
        method: 'POST',
        credentials: 'include'
      });

      if (response.ok) {
        toast.success('Weight logged successfully');
        setWeight('');
        fetchHistory();
      }
    } catch (error) {
      toast.error('Failed to log weight');
    }
  };

  const chartData = history.map(w => ({
    date: new Date(w.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
    weight: w.weight_kg
  }));

  return (
    <div className="p-4 md:p-8 max-w-4xl mx-auto">
      <h1 className="text-4xl font-bold mb-8">Weight Tracker</h1>

      <Card className="p-6 glass-card mb-6">
        <div className="flex items-center gap-3 mb-6">
          <Scale className="h-8 w-8 text-primary" />
          <h2 className="text-2xl font-bold">Log Weight</h2>
        </div>

        <div className="flex gap-3">
          <Input
            type="number"
            step="0.1"
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
            placeholder="Weight in kg"
          />
          <Button onClick={handleLog}>Log Weight</Button>
        </div>
      </Card>

      {history.length > 0 && (
        <Card className="p-6 glass-card">
          <h3 className="text-xl font-bold mb-6">Weight Trend</h3>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#27272A" />
              <XAxis dataKey="date" stroke="#A1A1AA" fontSize={12} />
              <YAxis stroke="#A1A1AA" fontSize={12} />
              <Tooltip
                contentStyle={{
                  backgroundColor: '#18181B',
                  border: '1px solid #3B82F6',
                  borderRadius: '8px'
                }}
              />
              <Line type="monotone" dataKey="weight" stroke="#3B82F6" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </Card>
      )}
    </div>
  );
}
